import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import Error from "../../../components/shared/error";
import withReducer from "../../../components/shared/with-reducer";
const PostInspectionAuthentication = loadable(() => import("../../../components/shared/post-inspection-authentication"), {ssr: true});
const PostInspectionDiyMetaTags = loadable(() => import("../../../components/shared/post-inspection-diy-meta-tags"), {ssr: true});
import injectableReducers from "./injectable";
import withCommonLayout from "../../../components/desktop/layout/component-common";

const PostInspection = ({isSSRError}) => {
    if (isSSRError) {
        return <Error />;
    }

    return (
        <React.Fragment>
            <PostInspectionDiyMetaTags />
            <PostInspectionAuthentication/>
        </React.Fragment>
    );
};

PostInspection.propTypes = {
    isSSRError: PropTypes.bool
};

export default withReducer(injectableReducers)(() => ({}), dispatch => ({ dispatch }))(withCommonLayout(PostInspection));

